import axios from "axios";
import AlertStore from '@/stores/AlertStore'

import {ENDPOINT_ENTREPRISES, ENDPOINT_SEARCH} from '@/constants/endpoints'
import {ENDPOINT_ENTREPRISES_SIREN_EXISTE, ENDPOINT_EXPORT, ENDPOINT_IMPORT} from "../constants/endpoints";

let store = {
  debug: true,

  get(id) {
    return axios
        .get(ENDPOINT_ENTREPRISES + '/' + id)
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  getBySiretOrLibelle(siretLibelle, mdmCheck, marcheId, modifyFlag, isMarcheInfo) {
    return axios
        .get(ENDPOINT_ENTREPRISES, {params: {siretLibelle, mdmCheck, marcheId, modifyFlag, isMarcheInfo}})
        .then(response => {
          if (response.data && response.data.length > 0) {
            return this.getEntreprisesAutocomplete(response.data);
          }
          return [];
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
          return [];
        })
  },

  getEntreprisesAutocomplete(entreprises) {
    return entreprises.map(entreprise => {
      return {
        text: entreprise.siret + ' (' + entreprise.libelle + ')',
        value: entreprise.id,
        entreprise: entreprise
      }
    });
  },
  getEntrepriseAutocomplete(entreprise) {
    return [{
      text: entreprise.siret + ' (' + entreprise.libelle + ')',
      value: entreprise.id,
      entreprise: entreprise
    }];
  },
  existsBySiren(siren) {
    return axios
        .get(ENDPOINT_ENTREPRISES_SIREN_EXISTE, {params: {siren}})
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  create(entreprise) {
    return axios
        .post(ENDPOINT_ENTREPRISES, entreprise)
        .then((value) => {
          AlertStore.pushSuccess('Entreprise créée avec succès.');
          return value.data;
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  update(entreprise) {
    return axios
        .put(ENDPOINT_ENTREPRISES, entreprise)
        .then(() => {
          AlertStore.pushSuccess('Entreprise modifiée avec succès.');
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  delete(id) {
    return axios
        .delete(ENDPOINT_ENTREPRISES + '/' + id)
        .then(() => {
          AlertStore.pushSuccess('Entreprise supprimée avec succès.');
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  search(entreprise, pageIndex, pageSize, sortOptions) {
    let recherche = [];
    recherche.push({key: 'libelle', operation: ':', value: entreprise.libelle});
    recherche.push({key: 'siren', operation: ':', value: entreprise.siren});
    recherche.push({key: 'siret', operation: ':', value: entreprise.siret});
    recherche.push({key: 'adresseSiren', operation: ':', value: entreprise.adresseSiren});
    recherche.push({key: 'villeSiren', operation: '=', value: entreprise.villeSiren});
    recherche.push({key: 'villeSirenAutre', operation: ':', value: entreprise.villeSirenAutre});
    recherche.push({key: 'paysSiren', operation: '=', value: entreprise.paysSiren});
    recherche.push({key: 'adresseSiret', operation: ':', value: entreprise.adresseSiret});
    recherche.push({key: 'villeSiret', operation: '=', value: entreprise.villeSiret});
    recherche.push({key: 'villeSiretAutre', operation: ':', value: entreprise.villeSiretAutre});
    recherche.push({key: 'paysSiret', operation: '=', value: entreprise.paysSiret});
    recherche.push({key: 'ess', operation: '=', value: entreprise.ess});

    let url = `${ENDPOINT_ENTREPRISES + ENDPOINT_SEARCH}?page=${pageIndex}&size=${pageSize}`;
    if (sortOptions) {
      for (const sortOption of sortOptions) {
        url += `&sort=${sortOption.sortBy},${sortOption.sortDirection}`;
      }
    }

    return axios.post(url, recherche);
  },

  import(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(ENDPOINT_ENTREPRISES + ENDPOINT_IMPORT, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  export() {
    let url = `${ENDPOINT_ENTREPRISES + ENDPOINT_EXPORT}`;
    return axios.get(url);
  },

  getInfoFournisseurBySiret(entrepriseId, marcheId) {
      return axios
          .get(ENDPOINT_ENTREPRISES + "/mdmfournisseur/" + entrepriseId + "/"+marcheId)
          .then(response => response.data)
          .catch(error => {
              AlertStore.pushError(error.response.data.message);
          })
  }
};

export default store;
